<template>
  <div>
    <h4 class="section-title">
      {{title}}
      <span class="section-sub-title">共為您搜尋到 {{verdictsCount}} 筆資料</span>
      <span class="section-sub-title">資料來源： 司法院</span>
    </h4>
    <div class="table-set">
      <div class="table-toolbar">
        <div class="toolbar-left">
          <el-date-picker
            v-model="startDate"
            type="date"
            placeholder="起始日期"
            size="mini"
            class="toolbar-input"
            value-format="yyyy-MM-dd"
            @change="search">
          </el-date-picker>
          <span class="connect">至</span>
          <el-date-picker
            v-model="endDate"
            type="date"
            placeholder="結束日期"
            size="mini"
            class="toolbar-input"
            value-format="yyyy-MM-dd"
            @change="search">
          </el-date-picker>
          <!-- @Q@ 暫先隱藏功能 -->
          <!-- <el-select class="toolbar-input" v-model="searchType" placeholder="搜尋方式" size="mini">
            <el-option
              v-for="item in searchTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              @change="search">
            </el-option>
          </el-select>
          <el-tooltip class="item" effect="dark" content="@Q@ 其實我也不知道這個是什麼" placement="bottom">
            <font-awesome-icon :icon="['far', 'question-circle']" style="vertical-align:middle;margin-right: 4px;"/>
          </el-tooltip>
          <el-select class="toolbar-input" v-model="judgmentType" placeholder="選擇判決" size="mini">
            <el-option
              v-for="item in judgmentTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              @change="search">
            </el-option>
          </el-select> -->
        </div>
      </div>
      <el-table
        :data="currentVerdicts.list"
        v-loading="isLoading"
        empty-text="目前暫無資料喔 :)"
        highlight-current-row
        stripe>
        <el-table-column
          label="序號"
          type="index"
          align="center"
          width="56">
        </el-table-column>
        <el-table-column
          label="管轄法院"
          width="160"
          prop="court">
        </el-table-column>
        <el-table-column
          label="判決類型"
          width="100"
          prop="type">
        </el-table-column>
        <el-table-column
          label="判決日期"
          width="100"
          prop="date">
        </el-table-column>
        <el-table-column
          label="判決字號"
          width="120"
          prop="uniID_part">
        </el-table-column>
        <el-table-column
          label="案由"
          prop="title">
        </el-table-column>
        <el-table-column
          label="判決全文"
          width="80">
          <template slot-scope="scope">
            <!-- <a href="#" target="_blank"> -->
            <router-link
              target="_blank"
              :to="returnJudgmentLinkTo(scope.row.uniID)">
              查看全文
            </router-link>
            <!-- </a> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="align-right">
      <el-pagination
        layout="prev, pager, next"
        :total="verdictsSearchableCount"
        :current-page.sync="currentPage"
        @current-change="search">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import * as apis from '@/apis/index.ts'
import * as codes from '@/const/codes.ts'
import * as config from '@/const/config.js'
import searchTypeOptions from '@/const/searchTypeOptions.js'
import judgmentTypeOptions from '@/const/judgmentTypeOptions.js'

export default {
  props: {
    'title': {
      default () {
        return codes.COMPANY_DETAIL_ITEM_DICT.verdicts
      }
    },
    'verdicts': {
      required: true,
      default () {
        return {
          list: [],
          stat: {}
        }
      }
    },
    // case 公司查詢
    'basic': {
      required: false,
      default () {
        return {
          list: [],
          stat: {}
        }
      }
    },
    'uniID': {
      required: false
    },
    // case 人物查詢
    'field': {
      required: false
    },
    'keyword': {
      required: false
    }
  },
  data () {
    return {
      searchTypeOptions,
      isLoading: false,
      judgmentTypeOptions,
      currentVerdicts: {
        list: [],
        stat: {}
      },
      startDate: '',
      endDate: moment().format('YYYY-MM-DD'),
      searchType: '',
      judgmentType: '',
      currentPage: 1
    }
  },
  computed: {
    verdictsCount () {
      if (this.currentVerdicts.stat['total-count']) {
        return this.currentVerdicts.stat['total-count']
      } else {
        return 0
      }
    },
    verdictsSearchableCount () {
      if (this.currentVerdicts.stat['total-count']) {
        if (this.currentVerdicts.stat['total-count'] > config.SEARCH_MAX_COUNT) {
          return config.SEARCH_MAX_COUNT
        } else {
          return this.currentVerdicts.stat['total-count']
        }
      } else {
        return 0
      }
    },
    // currentVerdictsList () {
    //   if (this.currentVerdicts.list.length && this.judgmentType) {
    //     return this.currentVerdicts.list.filter(d => {
    //       return d.type === this.judgmentType
    //     })
    //   } else {
    //     return this.currentVerdicts.list
    //   }
    // }
  },
  methods: {
    returnJudgmentLinkTo (uniID) {
      let query = {}
      // 如果是公司查詢加上關鍵字比對
      if (this.basic) {
        if (this.basic.company_name) {
          query.rCompany = this.basic.company_name
        }
        if (this.basic.representative_name) {
          query.rRepresentative = this.basic.representative_name
        }
        if (this.basic.shareholders && this.basic.shareholders.length) {
          query.rShareHolders = this.basic.shareholders.map(d => d.name).join(',')
        }
        if (this.basic.managers && this.basic.managers.length) {
          query.rManagers = this.basic.managers.map(d => d.name).join(',')
        }
      }
      return {
        name: 'verdictDetail',
        params: {
          uniID
        },
        query
      }
    },
    search () {
      let searchRequest = {
        get: {
          verdicts: {
            'page-index': this.currentPage,
            time: {}
          }
        }
      }
      if (this.startDate) {
        searchRequest.get.verdicts.time.start = this.startDate
      }
      if (this.endDate) {
        searchRequest.get.verdicts.time.end = this.endDate
      }
      // case 公司查詢
      if (this.uniID != null) {
        searchRequest.uniID = this.uniID
        this.isLoading = true
        apis.companyGet(searchRequest)
          .then((data) => {
            this.isLoading = false
            if (data.payload.verdicts) {
              this.currentVerdicts = data.payload.verdicts
            }
          })
          .catch(e => {
            this.isLoading = false
          })
      }
      // case 人物查詢
      else if (this.field != null) {
        searchRequest.basic = {
          field: this.field,
          keyword: this.keyword
        }
        this.isLoading = true
        apis.searchGet(searchRequest)
          .then((data) => {
            this.isLoading = false
            if (data.payload.verdicts) {
              this.currentVerdicts = data.payload.verdicts
            }
          })
          .catch(e => {
            this.isLoading = false
          })
      }
    }
  },
  watch: {
    'verdicts': {
      handler (d) {
        if (d) {
          this.currentVerdicts = JSON.parse(JSON.stringify(d))
        }
      },
      immediate: true
    }
  }
}
</script>
